import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
const idSchema = z.string().regex(/^\d+$/);
/**
 * BOSHLANG'ICH QOLDIQ — tizimdan OLDIN kelgan mahsulotlar.
 *
 * Bo'linmada yillar davomida yig'ilgan, hali ishlatilmagan mol bor: u
 * omborning javonidan o'tmagan, talabnomasi ham yo'q, lekin bugun
 * javonda turibdi va hisobda ko'rinishi kerak.
 *
 * Oddiy qabuldan IKKI narsa bilan farq qiladi:
 *
 *   1. SANA eski — har satr o'z kelgan sanasini olib keladi. Bugungi
 *      sana bilan yozilsa, «bu qachondan beri yotibdi» degan savolga
 *      hisobot yolg'on javob berardi.
 *   2. Umumiy ombor qoldig'iga TEGMAYDI — mol allaqachon bo'linmada
 *      va uni omborning javonida bordek ko'rsatish, o'z navbatida,
 *      boshqa odamning talabnomasiga yo'l ochardi.
 *
 * Kiritishning ikki yo'li bor va ikkalasi ham SHU satrlarga keladi:
 * Excel fayl va qo'lda kiritish. Server uchun farqi yo'q — fayl faqat
 * satrlarni tayyorlaydi.
 */
/** Bir hujjatdagi satrlar chegarasi — boshlang'ich qoldiq ham cheksiz emas. */
export const MAX_OPENING_ROWS = 2_000;
/**
 * Excel shablonining USTUNLARI — tartib SHU YERDA belgilanadi.
 *
 * Ro'yxat shartnomada turadi, chunki uni ikki tomon ham o'qiydi: server
 * faylni shu tartibda ajratadi, brauzer esa xuddi shu sarlavhalar bilan
 * bo'sh shablonni yuklab beradi. Ikki nusxa bo'lsa, ular bir kun
 * ajralib, odam yuklab olgan shablon rad etilardi.
 */
export const OPENING_SHEET_COLUMNS = [
    'Kod',
    'Nomi',
    'Miqdor',
    'Sana',
    'Akt №',
    'Izoh',
    'Ombor',
];
/**
 * Bitta satr — yozishga tayyor holda.
 *
 * `storeroomId` IXTIYORIY: faylda ombor ustuni bo'lsa har satr o'z
 * omboriga tushadi, bo'lmasa oynada tanlangani qo'llanadi. Ikkalasi
 * ham berilsa SATRNIKI ustun — u aniqroq.
 */
export const openingLineSchema = z.object({
    nomenclatureId: idSchema,
    qty: z.number().positive().max(1_000_000),
    /** Mol bo'linmaga QACHON kelgan — eski sana, shu satrniki. */
    receivedAt: z.coerce.date(),
    storeroomId: idSchema.nullish(),
    zoneId: idSchema.nullish(),
    /** Tashqi asos — eski akt yoki partiya raqami. */
    aktNo: z.string().trim().max(60).nullish(),
    note: z.string().trim().max(500).nullish(),
});
export const createOpeningSchema = z
    .object({
    /**
     * Partiya QAYSI ombor nomiga yoziladi.
     *
     * Berilmasa server bo'linmaning o'z korxonasidagi omborini oladi.
     * Partiyaning ombori — uning kelib chiqishi, javondagi qoldiq emas:
     * joylashuv yozilmaydi va umumiy qoldiq o'zgarmaydi.
     */
    warehouseId: idSchema.nullish(),
    /** Faylda ombor ko'rsatilmagan satrlar shu yerga tushadi. */
    storeroomId: idSchema,
    zoneId: idSchema.nullish(),
    note: z.string().trim().max(500).nullish(),
    lines: z.array(openingLineSchema).min(1).max(MAX_OPENING_ROWS),
})
    .transform((value) => ({
    warehouseId: value.warehouseId ?? null,
    storeroomId: value.storeroomId,
    zoneId: value.zoneId ?? null,
    note: value.note ?? null,
    lines: value.lines,
}));
/** Faylni tekshirgandagi bitta xato — odam Excel da AYNAN shu satrni topadi. */
export const openingSheetErrorSchema = z.object({
    row: z.number(),
    message: z.string(),
});
/**
 * Fayl tekshiruvining natijasi — HECH NARSA yozilmasdan.
 *
 * Satrlar ekranga qaytadi va odam ularni ko'rib tasdiqlaydi. Yozish
 * alohida so'rov bilan ketadi: «yukladim va o'tib ketdi» degan holat
 * boshlang'ich qoldiq uchun juda qimmat — uni orqaga qaytarish
 * hisobotlarni buzadi.
 */
export const openingPreviewRowSchema = z.object({
    row: z.number(),
    nomenclatureId: z.string(),
    nomenclatureName: z.string(),
    code: z.string(),
    unit: z.string(),
    qty: z.number(),
    receivedAt: z.string(),
    storeroomId: z.string().nullable(),
    storeroomName: z.string().nullable(),
    aktNo: z.string().nullable(),
    note: z.string().nullable(),
});
/**
 * KATALOGDAN TOPILMAGAN mahsulot — satr bo'yicha emas, MAHSULOT bo'yicha.
 *
 * Bitta «Bolt M12» o'n satrni to'xtatib tursa, odamdan ham bir marta
 * so'ralishi kerak, o'n marta emas. Bugungi tanilmagan BIRLIK bilan ayni
 * naqsh.
 */
export const openingUnknownItemSchema = z.object({
    /** Fayldagi matn — nomi, nom bo'lmasa kodi. */
    raw: z.string(),
    rowCount: z.number(),
    /** Birinchi uchragan satr — odam faylda topib ko'radi. */
    sheetRow: z.number(),
    qtyTotal: z.number(),
});
/**
 * TANILGAN USTUN — fayl qanday o'qilganining o'zi.
 *
 * Yuklash xatosining eng ko'p uchragan sababi — ustunning boshqa
 * tushunilgani: faylda «Сумма» ham, «Количество» ham bor va qaysi biri
 * miqdor deb olinganini odam ko'rmaydi. Shuning uchun moslik javobda
 * qaytadi va ekranda ko'rsatiladi: sababni odamning o'zi topadi, 162
 * satrlik xato ro'yxatidan taxmin qilmaydi.
 */
export const openingColumnSchema = z.object({
    field: z.enum(['code', 'name', 'qty', 'date', 'aktNo', 'note', 'storeroom']),
    /** Fayldagi sarlavha matni — odam o'z faylida aynan shuni ko'radi. */
    label: z.string(),
});
export const openingPreviewSchema = z.object({
    lines: z.array(openingPreviewRowSchema),
    errors: z.array(openingSheetErrorSchema),
    errorTotal: z.number(),
    /** Katalogda topilmagan mahsulotlar — odam ularni o'zi mos qo'yadi. */
    unknownItems: z.array(openingUnknownItemSchema),
    /** Fayldagi qaysi ustun qanday tushunilgani. */
    columns: z.array(openingColumnSchema),
});
/**
 * Kiritilgan hujjat — ro'yxatdagi bitta qator.
 *
 * `cancellable` SERVERDA hisoblanadi: bekor qilish faqat ichidagi
 * hech nima qimirlamagan bo'lsa mumkin va bu shartni ekran o'zi
 * taxmin qilmasligi kerak.
 */
export const openingRowSchema = z.object({
    id: z.string(),
    docNo: z.string(),
    subdivisionId: z.string(),
    note: z.string().nullable(),
    lineCount: z.number(),
    totalQty: z.number(),
    createdByName: z.string().nullable(),
    createdAt: z.string(),
    cancelledAt: z.string().nullable(),
    cancelledByName: z.string().nullable(),
    cancellable: z.boolean(),
});
export const openingQuerySchema = paginationQuerySchema;
//# sourceMappingURL=opening.js.map